import React from 'react'
import { Button } from '../../Button'
// Utils
import { Popover } from '../../Popover/Popover'
import { ErrorGroup } from '../../ErrorGroup'
import { FaExclamationTriangle } from 'react-icons/fa'

// Styles
import { S_FeeSummary, S_Indicator } from './FeeSummary.styles'
import { ButtonRow } from '../../layout/ButtonRow'

const errIndicator = (props) => {
  return (
    <S_Indicator {...props}>
      <FaExclamationTriangle />
    </S_Indicator>
  )
}

export const FeeSummary = ({ fee, summary = '', onEditClick = () => {}, onDeleteClick = () => {} }) => {
  return (
    <S_FeeSummary>
      <div className={'fee-summary'}>{summary}</div>
      {fee.errors && Object.keys(fee.errors).length ? (
        <Popover indicator={errIndicator}>
          <ErrorGroup description={''} errors={Object.keys(fee.errors).map((key) => fee.errors[key])} />
        </Popover>
      ) : null}
      <ButtonRow className={'fee-summary-actions'}>
        <Button className={'compact'} onClick={() => onEditClick(fee)}>
          Edit
        </Button>
        <Button className={'compact destroy'} onClick={() => onDeleteClick(fee)}>
          Delete
        </Button>
      </ButtonRow>
    </S_FeeSummary>
  )
}
